import React, { useState } from "react";
import moment from "moment/moment";
import { Badge } from "primereact/badge";

import { SecondaryButton } from "../../../../Components/Button";
import AssignOrderModal from "./AssignOrderModal";

const DispatchOrderCard = ({ selectedSubTab,OrderDataFun,item,activeType, fetchAllDeliveryMan, allDeliveryMan }) => {
  // console.log("item order:",item);
  const [isAssignModal,setIsAssignModal]=useState(false);
  const [isAssignItem,setIsAssignItem]=useState('');
  return (
    <div className="border-b p-2 rounded-md">
      <div className="flex justify-between">
        <div>
          <p>{item.delivery_address.name}</p>
          <p>{item.delivery_address.phone_number}</p>
        </div>
        <div className="text-end">
          <p> {item.order_id}</p>
          <p>{moment(item.order_date).format("MMM Do, YYYY")}</p>
        </div>
      </div>
      <p>
        {item.delivery_address.street},{item.delivery_address.city.name},
        {item.delivery_address.country.name}
      </p>
      <div className="flex justify-between gap-2 items-center">
      <Badge
          className="text-[10px] px-2"
          severity={"info"}
          value={activeType==="Ecommerce"&&  item?.orderDetails?.[0]?.delivery_status
            || item?.delivery_status}
        />
       
      <button 
      className="px-1 py-1 border border-blue-500 text-blue-600 rounded-xl hover:bg-blue-100" 
      onClick={() => {
        setIsAssignModal(true);
        setIsAssignItem(item);
        fetchAllDeliveryMan();
      }}
      >{selectedSubTab?"Re-assign Delivery":"Assign Delivery"}
      </button>
         
      </div>
      {isAssignModal && (
        <AssignOrderModal OrderDataFun={OrderDataFun} activeType={activeType} selectedSubTab={selectedSubTab} allDeliveryMan={allDeliveryMan} isAssignModal={isAssignModal} itemData={item} setIsAssignModal={setIsAssignModal}/>
      )}
    </div>
  );
};

export default DispatchOrderCard;
